
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 18 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.473 4.097l-6.5 2.48A1.528 1.528 0 004 8.01v7.158c0 .578.322 1.106.828 1.364l6.502 3.307c.421.216.918.216 1.34 0l6.502-3.307c.51-.258.828-.789.828-1.364V8.009c0-.636-.388-1.206-.972-1.428L12.527 4.1a1.45 1.45 0 00-1.054-.004zm.529 1.975l6 2.29v.035l-6 2.48L6 8.397v-.035l6.002-2.29zm1 11.32v-4.734l5-2.067v4.258l-5 2.543z","fill":"#282828"}})])
          )
        }
      }
    